export const FETCH_USER_LIST = "FETCH_USER_LIST"

export const UPDATE_LOADING_STATUS = "UPDATE_LOADING_STATUS"
export const UPDATE_SELECTED_PROJECT = "UPDATE_SELECTED_PROJECT"
export const FETCH_SELECTED_PROJECT_MEMBER_LIST = "FETCH_SELECTED_PROJECT_MEMBER_LIST"
export const FETCH_SELECTED_PROJECT_AVAILABLE_MEMBER_LIST = "FETCH_SELECTED_PROJECT_AVAILABLE_MEMBER_LIST"
export const UPDATE_PROJECT_STATUS = "UPDATE_PROJECT_STATUS"
export const ADD_MEMBER_TO_PROJECT = "ADD_MEMBER_TO_PROJECT"
export const REMOVE_MEMBER_FROM_PROJECT = "REMOVE_MEMBER_FROM_PROJECT"
export const UPDATE_PROJECT_MEMBER_AUTH = "UPDATE_PROJECT_MEMBER_AUTH"
export const UPDATE_PREVIEW_PANEL_INFO = "UPDATE_PREVIEW_PANEL_INFO"
export const UPDATE_ITEM_SMART_SUGGESTION_LIST = "UPDATE_ITEM_SMART_SUGGESTION_LIST"
export const FETCH_PROJECT_BACKGROUND_INFORMATION = "FETCH_PROJECT_BACKGROUND_INFORMATION"
export const FETCH_PROJECT_SUMMARY = "FETCH_PROJECT_SUMMARY"
export const UPDATE_PROJECT_DUE = "UPDATE_PROJECT_DUE"
export const UPDATE_PROJECT_DOCUMENT_DUE = "UPDATE_PROJECT_DOCUMENT_DUE"

export const LOGOUT = "LOGOUT"
export const UPDATE_LOGIN_STATUS = "UPDATE_LOGIN_STATUS"
export const CHECK_LOGIN_STATUS = "CHECK_LOGIN_STATUS"
export const FETCH_USER_DATA = "FETCH_USER_DATA"
export const CLEAR_ERROR_MSG = "CLEAR_ERROR_MSG"

export const FETCH_ALL_PROJECT_LIST = "FETCH_ALL_PROJECT_LIST"
export const FETCH_ACTIVE_PROJECT_LIST = "FETCH_ACTIVE_PROJECT_LIST"
// export const SELECT_ACTIVE_PROJECT = "SELECT_ACTIVE_PROJECT"
export const FETCH_ACTIVE_PROJECT_MEMBER_LIST = "FETCH_ACTIVE_PROJECT_MEMBER_LIST"
export const FETCH_ACTIVE_PROJECT_AVAILABLE_MEMBER_LIST = "FETCH_ACTIVE_PROJECT_AVAILABLE_MEMBER_LIST"
export const ADD_MEMBER_TO_ACTIVE_PROJECT = "ADD_MEMBER_TO_ACTIVE_PROJECT"
export const REMOVE_MEMBER_FROM_ACTIVE_PROJECT = "REMOVE_MEMBER_FROM_ACTIVE_PROJECT"
export const UPDATE_ACTIVE_PROJECT_MEMBER_AUTH = "UPDATE_ACTIVE_PROJECT_MEMBER_AUTH"

export const FETCH_DOCUMENT_LIST = "FETCH_DOCUMENT_LIST"
export const FETCH_DOCUMENT_CONTENT = "FETCH_DOCUMENT_CONTENT"
export const FETCH_TEMPLATE_LIST = "FETCH_TEMPLATE_LIST"
export const FETCH_TEMPLATE_CONTENT = "FETCH_TEMPLATE_CONTENT"
export const UPDATE_TEMPLATE = "UPDATE_TEMPLATE"

export const UPDATE_ITEM_LIST = "UPDATE_ITEM_LIST"
export const UPDATE_UNIT_LIST = "UPDATE_UNIT_LIST"
export const UPDATE_AVILABLE_CONTACT_PERSON_LIST = "UPDATE_AVILABLE_CONTACT_PERSON_LIST"
export const UPDATE_LOCATION_LIST = "UPDATE_LOCATION_LIST"
export const UPDATE_ESTATE_LIST = "UPDATE_ESTATE_LIST"
export const FETCH_PROJECT_DOCUMENT = "FETCH_PROJECT_DOCUMENT"
export const FETCH_MAIN_QUOTATION = "FETCH_MAIN_QUOTATION"
export const REQUEST_REDIRECT = "REQUEST_REDIRECT"


// WEBPACK FOOTER //
// ./src/ActionTypes.js